import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1492ca00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login xag-container xag-flex-vertical" }
const _hoisted_2 = { class: "xag-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "进入页面或者刷新页面获取以下的token，测试", -1))
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "test-content" }, "底部啦")
], -1))
const _hoisted_6 = { style: {"line-height":"1.5"} }
const _hoisted_7 = { style: {"line-height":"1.6"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { style: {"word-break":"break-word"} }
const _hoisted_11 = { style: {"word-break":"break-word"} }
const _hoisted_12 = { style: {"word-break":"break-word"} }
const _hoisted_13 = {
  class: "xag-page__footer",
  style: {"text-align":"center","line-height":"40px","background":"#e4e4e4"}
}

import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import wx from 'weixin-js-sdk'
import wxHost from '@/utils/wx'
import { login } from '@/apis/user'
import AppHeader from '@/components/Header.vue'
import appHost, { isAndrod, isIos } from '@/utils/app'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'AppLogin',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore()
const token = ref('')
const statusBarHeight = ref(0)
const result = ref()
const wxReady = ref(false)
const getEnvRes = ref('')
const mLocation = ref<{ latitude: number; longitude: number; speed: number; accuracy: number }>()
const miniprogram = ref('')

function ready() {
  console.log(window.__wxjs_environment === 'miniprogram') // true
  miniprogram.value += ' ready '
}

if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
  miniprogram.value += ' WeixinJSBridge '
  document.addEventListener('WeixinJSBridgeReady', ready, false)
} else {
  ready()
}

const href = window.location.href

let flag = 0
function getEnv() {
  getEnvRes.value += flag++ + ' | '
  wx.miniProgram.getEnv((res) => {
    getEnvRes.value += JSON.stringify(res)
    wxReady.value = res.miniprogram
  })
}

async function todo() {
  const result = await login({ username: 'kelin', password: '123456' })
  // const result = await login({ username: 'ztz', password: '123456' })
  console.log(result.access_token)
  token.value = result?.access_token || ''
  console.log(token.value)
}
if (isAndrod || isIos) {
  appHost.getStatusBarHeight((px: number) => {
    statusBarHeight.value = px
  })
}
const devicePixelRatio = window.devicePixelRatio
todo()
getEnv()

wxHost.config().then(() => {
  wx.getLocation({
    type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
    success(res) {
      console.log('success', res)
      mLocation.value = res
    },
    fail(res) {
      console.log('fail', res)
      mLocation.value = res
    },
  })
})

setTimeout(() => {
  wxHost.config()
}, 0)

const userAgent = window.navigator.userAgent
function navigateToPhone(url: string) {
  wx.miniProgram.navigateTo({
    url: `${url}?phone=15915797485&name=${encodeURIComponent('柯琳')}&title=${encodeURIComponent(
      '故障报修'
    )}`,
  })
}
function navigateToMini(url: string) {
  wx.miniProgram.navigateTo({
    url,
  })
}
function redirectToMini(url: string) {
  wx.miniProgram.redirectTo({
    url,
  })
}

const router = useRouter()

function onGo() {
  router.push({
    path: '/protoc',
    query: {
      title: '老用户购机优惠须知',
      url: 'https://app.xag.cn/help_doc/a966ba16-dae3-48be-9fc4-7e66213f8fc3',
    },
  })
}

function onGo1() {
  router.push({
    path: '/protoc',
    query: {
      title: '告知使用注意说明书',
      url: 'https://app.xag.cn/help_doc/c81ee0e6-c15c-4970-ae32-6c0a5744e74f',
    },
  })
}

function onGo2() {
  router.push({
    path: '/protoc',
    query: {
      title: '备用产品使用合同',
      url: 'https://app.xag.cn/help_doc/2fec19dc-9d74-413a-a8f1-2b26e9b15f5a',
    },
  })
}
function onGo3() {
  router.push({
    path: '/protoc',
    query: {
      title: '备用产品使用规则',
      url: 'https://app.xag.cn/help_doc/4ed2f685-cb1c-446c-b0af-271fa17141ae',
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, { title: "WEB-TEST" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(token.value), 1),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onGo()))
        }, "老用户购机优惠须知"),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onGo1()))
        }, "告知使用注意说明书"),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onGo2()))
        }, "备用产品使用合同"),
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (onGo3()))
        }, "备用产品使用规则")
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createTextVNode(" getStatusBarHeight: "),
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_unref(store).state.appNavHeight) + "/" + _toDisplayString(statusBarHeight.value) + "/" + _toDisplayString(_unref(devicePixelRatio)), 1)
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(" userAgent: "),
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_unref(userAgent)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, "href/" + _toDisplayString(_unref(href)), 1),
      _createElementVNode("div", _hoisted_11, "mLocation/" + _toDisplayString(mLocation.value), 1),
      _createElementVNode("div", _hoisted_12, "getEnvRes/" + _toDisplayString(getEnvRes.value) + "/" + _toDisplayString(miniprogram.value), 1),
      _createElementVNode("div", null, _toDisplayString(result.value), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (navigateToPhone('/pages--user/phone')))
      }, "打电话"),
      (wxReady.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (navigateToMini('/pages--user/baseInfo')))
            }, "/pages--user/baseInfo"),
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (redirectToMini('/pages--user/baseInfo')))
            }, "/pages--user/baseInfo")
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})